import { FlexCenter } from "../../../common/UI/Flex.js";
import { Shadows } from "../../../common/UI/Shadows.js";
import { Label } from "../Styles.js";
import styled, { css } from "styled-components";
const Switch = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${(props) => {
  if (props.removed)
    return props.theme.boolean.toggleRemoved;
  if (props.error)
    return props.theme.boolean.toggleError;
  if (props.warning)
    return props.theme.boolean.toggleWarning;
  if (props.checked)
    return props.theme.boolean.toggleChecked;
  return props.theme.boolean.toggleDefault;
}};
  border-radius: 100px;
  position: relative;
`;
const SwitchWrapper = styled.div`
  width: 22px;
  height: 12px;
  margin-right: 8px;
  flex-shrink: 0;
`;
const Knob = styled.div`
  height: 9.33px;
  width: 9.33px;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: 10px;
  position: absolute;
  left: ${(props) => props.checked ? "11.33px" : "1.33px"};
  top: 1.33px;
  box-shadow: ${Shadows.switchKnob};
  transition: ease-in-out left 0.1s;
`;
const KnobIcon = styled.div`
  display: flex;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-weight: 700;
  color: ${(props) => {
  if (props.removed)
    return props.theme.boolean.toggleRemoved;
  if (props.error)
    return props.theme.boolean.toggleError;
  if (props.warning)
    return props.theme.boolean.toggleWarning;
  if (props.checked)
    return props.theme.boolean.toggleChecked;
  return props.theme.boolean.toggleDefaultIcon;
}};
`;
const ContentWrapper = styled.div`
  ${FlexCenter}
  position: relative;
  max-width: ${(props) => props.diff ? "50%" : "100%"};
  cursor: ${(props) => props.readOnly ? "default" : "pointer"};
  padding: 5px 5px 5px 0;

  ${(props) => props.removed && css`
      ${Label} {
        color: ${props.theme.cell.removedColor};
      }

      &:after {
        content: '';
        height: 1px;
        background-color: ${props.theme.cell.removedColor};
        position: absolute;
        top: 50%;
        right: -4px;
        left: -4px;
      }
    `}
`;
const ContentInner = styled.div`
  ${FlexCenter}
  overflow: hidden;
`;
export {
  ContentInner,
  ContentWrapper,
  Knob,
  KnobIcon,
  Switch,
  SwitchWrapper
};
